<template>
    <div :class="containerClass">
        <h2
            v-if="conditionalCourseTitle"
            class="h-6 flex flex-row justify-center items-center text-xs overflow-hidden"
            v-text="conditionalCourseTitle"
        ></h2>
        <div class="flex flex-col flex-wrap">
            <sco-row
                v-for="sco in course"
                :key="sco.sco_user_id"
                :sco="sco"
                :slug="slugify(sco.title)"
                :row-index="rowIndex"
                :course="course"
            ></sco-row>
        </div>
    </div>
</template>

<script>
import ScoRow from "@/components/courses/ScoRow.vue";
import slugify from "slugify";

export default {
    name: "CourseRow",
    components: {
        ScoRow
    },
    props: {
        course: {
            type: Array,
            required: true
        },
        rowIndex: {
            type: Number,
            required: true
        }
    },
    computed: {
        containerClass() {
            if (this.course.length === 2) {
                return "border-2 border-black";
            }

            return "";
        },
        conditionalCourseTitle() {
            if (this.course.length > 1) {
                return this.course[0].course_title;
            }

            return "";
        }
    },
    methods: {
        slugify(title) {
            return slugify(title, { lower: true, strict: true, locale: "en" });
        }
    }
};
</script>
